:host {
  display: block;
  font-family: var(--semantic-typography-font-family-secondary), var(--font-fallbacks);
  color: var(--wink-title-color, var(--semantic-color-text-default));

  b,
  strong,
  .bold {
    font-weight: var(--title-bold-font-weight, 700);
  }

  small,
  .light {
    font-size: inherit;
    font-weight: var(--title-light-font-weight, 400);
    line-height: inherit;
  }

  .title-huge,
  .display-huge {
    margin-top: var-rem(--semantic-spacing-4xl);
    margin-bottom: var-rem(--semantic-spacing-xl);
    font-size: var-rem(--semantic-typography-font-size-huge);
    line-height: var-rem(--semantic-typography-line-height-huge);
  }

  .title-3xl,
  .display-3xl,
  h1 {
    margin-top: var-rem(--semantic-spacing-4xl);
    margin-bottom: var-rem(--semantic-spacing-xl);
    font-size: var-rem(--semantic-typography-font-size-3xl);
    line-height: var-rem(--semantic-typography-line-height-3xl);
  }

  .title-2xl,
  .display-2xl,
  h2 {
    margin-top: var-rem(--semantic-spacing-xl);
    margin-bottom: var-rem(--semantic-spacing-3xs);
    font-size: var-rem(--semantic-typography-font-size-2xl);
    line-height: var-rem(--semantic-typography-line-height-2xl);
  }

  .title-xl,
  .display-xl,
  h3 {
    margin-top: var-rem(--semantic-spacing-xl);
    margin-bottom: var-rem(--semantic-spacing-3xs);
    font-size: var-rem(--semantic-typography-font-size-xl);
    line-height: var-rem(--semantic-typography-line-height-xl);
  }

  .title-lg,
  h4 {
    margin-top: var-rem(--semantic-spacing-xl);
    margin-bottom: var-rem(--semantic-spacing-3xs);
    font-size: var-rem(--semantic-typography-font-size-lg);
    line-height: var-rem(--semantic-typography-line-height-md);
  }

  .display-lg {
    margin-top: var-rem(--semantic-spacing-xl);
    margin-bottom: var-rem(--semantic-spacing-3xs);
    font-size: var-rem(--semantic-typography-font-size-lg);
    line-height: var-rem(--semantic-typography-line-height-lg);
  }

  .title-md,
  h5 {
    margin-top: var-rem(--semantic-spacing-xl);
    margin-bottom: var-rem(--semantic-spacing-3xs);
    font-size: var-rem(--semantic-typography-font-size-md);
    line-height: var-rem(--semantic-typography-line-height-sm);
  }

  .display-md {
    margin-top: var-rem(--semantic-spacing-xl);
    margin-bottom: var-rem(--semantic-spacing-3xs);
    font-size: var-rem(--semantic-typography-font-size-md);
    line-height: var-rem(--semantic-typography-line-height-md);
  }

  .title-sm,
  h6 {
    margin-top: var-rem(--semantic-spacing-md);
    margin-bottom: var-rem(--semantic-spacing-none);
    font-size: var-rem(--semantic-typography-font-size-sm);
    line-height: var-rem(--semantic-typography-line-height-sm);
  }

  .display-sm {
    margin-top: var-rem(--semantic-spacing-md);
    margin-bottom: var-rem(--semantic-spacing-none);
    font-size: var-rem(--semantic-typography-font-size-sm);
    line-height: var-rem(--semantic-typography-line-height-md);
  }

  .display-huge {
    --title-bold-font-weight: bolder;
    --title-light-font-weight: var(--semantic-typography-font-weight-title-huge);

    font-weight: var(--semantic-typography-font-weight-display-huge);
  }

  .display-3xl {
    --title-bold-font-weight: bolder;
    --title-light-font-weight: var(--semantic-typography-font-weight-title-3xl);

    font-weight: var(--semantic-typography-font-weight-display-3xl);
  }

  .display-2xl {
    --title-bold-font-weight: bolder;
    --title-light-font-weight: var(--semantic-typography-font-weight-title-2xl);

    font-weight: var(--semantic-typography-font-weight-display-2xl);
  }

  .display-xl {
    --title-bold-font-weight: bolder;
    --title-light-font-weight: var(--semantic-typography-font-weight-title-xl);

    font-weight: var(--semantic-typography-font-weight-display-xl);
  }

  .display-lg {
    --title-bold-font-weight: bolder;
    --title-light-font-weight: var(--semantic-typography-font-weight-title-lg);

    font-weight: var(--semantic-typography-font-weight-display-lg);
  }

  .display-md {
    --title-bold-font-weight: bolder;
    --title-light-font-weight: var(--semantic-typography-font-weight-title-md);

    font-weight: var(--semantic-typography-font-weight-display-md);
  }

  .display-sm {
    --title-bold-font-weight: bolder;
    --title-light-font-weight: var(--semantic-typography-font-weight-title-sm);

    font-weight: var(--semantic-typography-font-weight-display-sm);
  }

  .title-huge {
    --title-bold-font-weight: var(--semantic-typography-font-weight-display-huge);
    --title-light-font-weight: var(--semantic-typography-font-weight-regular);

    font-weight: var(--semantic-typography-font-weight-title-huge);
  }

  .title-3xl,
  h1 {
    --title-bold-font-weight: var(--semantic-typography-font-weight-display-3xl);
    --title-light-font-weight: var(--semantic-typography-font-weight-regular);

    font-weight: var(--semantic-typography-font-weight-title-3xl);
  }

  .title-2xl,
  h2 {
    --title-bold-font-weight: var(--semantic-typography-font-weight-display-2xl);
    --title-light-font-weight: var(--semantic-typography-font-weight-regular);

    font-weight: var(--semantic-typography-font-weight-title-2xl);
  }

  .title-xl,
  h3 {
    --title-bold-font-weight: var(--semantic-typography-font-weight-display-xl);
    --title-light-font-weight: var(--semantic-typography-font-weight-regular);

    font-weight: var(--semantic-typography-font-weight-title-xl);
  }

  .title-lg,
  h4 {
    --title-bold-font-weight: var(--semantic-typography-font-weight-display-xl);
    --title-light-font-weight: var(--semantic-typography-font-weight-regular);

    font-weight: var(--semantic-typography-font-weight-title-lg);
  }

  .title-md,
  h5 {
    --title-bold-font-weight: var(--semantic-typography-font-weight-display-lg);
    --title-light-font-weight: var(--semantic-typography-font-weight-regular);

    font-weight: var(--semantic-typography-font-weight-title-md);
  }

  .title-sm,
  h6 {
    --title-bold-font-weight: var(--semantic-typography-font-weight-display-md);
    --title-light-font-weight: var(--semantic-typography-font-weight-regular);

    font-weight: var(--semantic-typography-font-weight-title-sm);
  }

  &.color--default {
    color: var(--semantic-color-text-default);
  }

  &.color--subtle {
    --wink-title-color: var(--semantic-color-text-subtle);

    color: var(--semantic-color-text-subtle);
  }

  &.color--subtlest {
    --wink-title-color: var(--semantic-color-text-subtlest);

    color: var(--semantic-color-text-subtlest);
  }

  &.color--inverse {
    --wink-title-color: var(--semantic-color-text-inverse);

    color: var(--semantic-color-text-inverse);
  }

  &.color--accent {
    --wink-title-color: var(--semantic-color-text-accent-title);

    color: var(--semantic-color-text-accent-title);
  }
}

:host(.spacing-top) * {
  margin-bottom: var-rem(--semantic-spacing-none);
}

:host(.spacing-bottom) * {
  margin-top: var-rem(--semantic-spacing-none);
}

:host(.spacing-none) * {
  margin-top: var-rem(--semantic-spacing-none);
  margin-bottom: var-rem(--semantic-spacing-none);
}

:host(.alignment-left) * {
  text-align: left;
}

:host(.alignment-center) * {
  text-align: center;
}

:host(.alignment-right) * {
  text-align: right;
}

:host(.is-flow-rendition) {
  .title-3xl,
  .display-3xl {
    font-size: 3.6rem;
    line-height: 4rem;

    @include media-header('from-lg') {
      font-size: 3.6rem;
      line-height: 4.4rem;
    }
  }

  .title-2xl,
  .display-2xl {
    font-size: 2.8rem;
    line-height: 3.6rem;

    @include media-header('from-lg') {
      font-size: 3.2rem;
      line-height: 4rem;
    }
  }

  .title-xl,
  .display-xl {
    font-size: 2.4rem;
    line-height: 3.2rem;

    @include media-header('from-lg') {
      font-size: 2.8rem;
      line-height: 3.6rem;
    }
  }

  .title-lg,
  .display-lg {
    font-size: 2rem;
    line-height: 2.8rem;

    @include media-header('from-lg') {
      font-size: 2.4rem;
      line-height: 3.2rem;
    }
  }

  .title-md,
  .display-md {
    font-size: 1.8rem;
    line-height: 2.4rem;

    @include media-header('from-lg') {
      font-size: 2rem;
      line-height: 2.8rem;
    }
  }

  .title-sm,
  .display-sm {
    font-size: 1.6rem;
    line-height: 2.4rem;

    @include media-header('from-lg') {
      font-size: 1.8rem;
      line-height: 2.8rem;
    }
  }
}
